import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import RssFeedIcon from '@mui/icons-material/RssFeed';
import RssFeedRoundedIcon from '@mui/icons-material/RssFeedRounded';
import { getAllFeeds, getLatestFeedArticle } from '../audiblogsApi';
import logo from '../sidebar-logo.png';
import './FeedsDirectory.scss';

const FeedsDirectory = () => {
  const [feeds, setFeeds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAllFeeds()
      .then(async (response) => {
        if (response?.data?.feeds) {
          const processedFeeds = response.data.feeds.map(feed => ({
            ...feed,
            feed_id: feed.feed_id || feed.id,
            title: feed.title || feed.name || 'Untitled Feed',
          }));

          const feedsWithThumbnails = await Promise.all(
            processedFeeds.map(async (feed) => {
              try {
                if (feed.feed_id) {
                  const latestArticle = await getLatestFeedArticle(feed.feed_id);
                  if (latestArticle) {
                    return {
                      ...feed,
                      thumbnail_url: latestArticle.thumbnail_url || feed.thumbnail_url,
                      latest_article: latestArticle
                    };
                  }
                }
                return feed;
              } catch (error) {
                console.error(`Error fetching latest article for feed ${feed.feed_id}:`, error);
                return feed;
              }
            })
          );

          setFeeds(feedsWithThumbnails);
        }
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching feeds:', error);
        setLoading(false);
      });
  }, []);

  return (
    <div className="feeds-directory">
      <div className="nav-bar">
        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <img src={logo} className="audiblogs-logo" alt="logo" />
          </Link>
          <div style={{ marginLeft: '50px' }} className="ph-badge">
            <a
              href="https://www.producthunt.com/posts/audiblogs?utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-audiblogs"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=283759&theme=dark&period=monthly"
                alt="Audioread - Listen to any web article in your podcast player | Product Hunt"
                style={{ width: '250px', height: '54px' }}
                width="250"
                height="54"
              />
            </a>
          </div>
        </div>
        <div className="desktop-nav">
          <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '20px', fontSize: '1.05rem', fontWeight: 'bold' }}>
            <Link
              className="signin-button"
              to="/freeaitexttospeech"
            >
              Free Converter
            </Link>
            <Link
              className="signin-button"
              to={{ pathname: "https://help.audioread.com/en/collections/12375780-use-cases" }}
              target="_blank"
            >
              Use Cases
            </Link>
            <Link className="signin-button" to="/signin">
              Sign In
            </Link>
            <div className="cta-div" style={{ position: 'static', width: 'auto', paddingBottom: '18px' }}>
              <Link className="cta-button" to="/onboarding/trial" style={{ marginTop: '0px' }}>
                Try for Free
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="feeds-content">
        <div className="page-title">
          <RssFeedRoundedIcon sx={{ 
            fontSize: '3rem',
            background: 'linear-gradient(135deg, #4292fa 0%, #e82186 100%)',
            borderRadius: '50%',
            padding: '10px',
            marginRight: '15px',
            boxShadow: '0 4px 20px rgba(66, 146, 250, 0.3)'
          }} />
          <h1>Feeds</h1>
        </div>
        {loading ? (
          <div className="loading-container">
            <CircularProgress />
          </div>
        ) : (
          <div className="feeds-grid">
            {feeds.map((feed) => (
              <Link 
                key={feed.feed_id}
                to={`/feed/${feed.feed_id}`}
                className="feed-card"
              >
                {feed.thumbnail_url && (
                  <img 
                    src={feed.thumbnail_url} 
                    alt={feed.title}
                    className="feed-thumbnail"
                  />
                )}
                <div className="feed-info">
                  <h3>{feed.title}</h3>
                  <p>{feed.description}</p>
                </div>
                <div className="rss-link">
                  <RssFeedIcon />
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FeedsDirectory; 